/*  React  */
import { CellContext, Row } from '@tanstack/react-table';

/* Shared */
import { TenantApp } from 'application/Shared/types/tenantApp';

/* React */
import React from 'react';

/*  Objects  */
import { LicenseData } from '../LicenseUsage/LicenseData';
import { getLicenseDataStatus } from '../LicenseUsage/functions';
import { LicenseDataFilter } from '../LicenseUsage/types';
import { ColumnFilter } from '../Table/types';

/**
 * Configuration object for license data filtering control.
 */
export const licenseDataCellFilter: ColumnFilter<unknown> = {
    control: 'Checkbox',
    defaultOptions: [{ options: LicenseDataFilter }]
};

/**
 * Filter function for license data cells in a table
 * @param {Row<TenantApp>} row - The row data containing tenant app information
 * @param {string} columnId - The ID of the column being filtered
 * @param {string} filterValue - The filter value to match against
 * @returns {boolean} True if the row should be included in filtered results, false otherwise
 */
export function licenseDataCellFilterFn<TenantApp>(
    row: Row<TenantApp>,
    columnId: string,
    filterValue: string[]
): boolean {
    if (!filterValue) return true;

    const filterValueArray = Array.isArray(filterValue)
        ? filterValue
        : [filterValue];

    if (filterValueArray.length === 0) return true;

    // @ts-expect-error FIXME
    const status = getLicenseDataStatus(row.original);
    return filterValueArray.includes(status);
}

/**
 * A cell component for displaying license data in a table
 * @param {CellContext<TenantApp, unknown>} props - The cell context props from react-table
 * @param {object} props.row - The row data containing the tenant app information
 * @param {object} props.rest - Additional props to pass to the LicenseData component
 * @returns {JSX.Element} LicenseData component with tenant app data
 */
export const LicenseDataCell = ({
    row,
    ...rest
}: CellContext<TenantApp, unknown>): JSX.Element => (
    <LicenseData tenantApp={row.original} {...rest} />
);
